import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {compose, lifecycle} from 'recompose'
import {injectIntl} from 'react-intl'

import {getFullFundInfo} from '../selectors/funds.js'
import {getFund} from '../store/reducers/funds/list.js'
import {getLots, getPersons, clear, getFunds} from '../store/reducers/funds/fund.js'

import MainContainer from './Main'
import SingleList from './LotList/singleList'
import Sidebar from './../components/Fund/Sidebar'
import BidHistory from '../components/Lot/BidHistory'
import DonationStats from '../components/Fund/DonationStats'
import numeral from 'numeral'
import Link from './../components/Link'
import PdfLogo from '../components/Icons/Pdf'

const FundPage = ({info, lots = [], persons = [], intl, actions = []}) => {
  console.log('info', info)
  if (info) return (
    <div className='Container'>
      <div className="Found">
        <div className="Found__row">
          <div className="Found__col">
            <div className='Found__head'>{info.name}</div>
            <Link className='Link_orange Found__link' to={info.webSite}>{info.webSite}</Link>
          </div>
          <div className="Found__col-right">
            <div className='Found__donations'>В пользу фонда
              собрано {(numeral(info.sumOfExternalPayments).format('0,0') == 0)
                ? 'coming soon' : (numeral(info.sumOfExternalPayments).format('0,0') + ' ₽')}</div>
          </div>
        </div>

        {/*<a href={info.webSite} target='_blank' className='Link Found__link'>info.webSite</a>
      <DonationStats info={info.lotsStats} />*/}
        <div className='Found__description' dangerouslySetInnerHTML={{__html: info.description}}/>

        <div className='Found__list'>
          <div className='Found__list-header'>Проведенные акции</div>
          {actions.map(el => (
            <div className='Found__list-row' key={el._id}>
              <div className='Found__list-col'>{el.title}</div>
              <div
                className='Found__list-col-right'>{(numeral(el.externalPaymentsStats.sum).format('0,0') == 0) ? 'coming soon' :
                (numeral(el.externalPaymentsStats.sum).format('0,0') + ' ₽')}
                {/*<button type="button" className="Found__pdf-button"><PdfLogo /></button>*/}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    /*<MainContainer
      sidebarNoBody
      Sidebar={
        <Sidebar data={info} />
      }
    >
      <DonationStats info={info.lotsStats} />
      <div className='Main__description Text' dangerouslySetInnerHTML={{ __html: info.description }} />
      <SingleList items={lots} title={intl.formatMessage({id: 'fund.active_auctions'})} withPadding={persons.length > 0} />
      {persons.length > 0 && (<BidHistory items={persons} title={intl.formatMessage({id: 'fund.participants_supported'})} />)}
    </MainContainer>
    */
  ); else return null
}

const mapStateToProps = () => {
  const getInfo = getFullFundInfo()

  return (state, props) => {
    //console.log('state.funds', state.funds)
    //console.log('props', props)
    return ({
      info: getInfo(state, props),
      ...state.funds.fund
    })
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({getFund, getLots, getPersons, clear, getFunds}, dispatch)

const mergeProps = (state, dispatch, props) => {
  const getDetails = async (id) => {
    if (!id) return
    await Promise.all([
      dispatch.getLots(id),
      dispatch.getPersons(id),
      dispatch.getFunds(id)
    ])
  }

  const getInfo = async (id) => {
    id = id || props.id
    if (!id) return

    let code
    if (!props.info) code = await dispatch.getFund(id)
    if (props.info || code === 200) await getDetails(id)
    if (!props.info && code !== 200) props.on404()
  }

  return {...props, ...state, getInfo}
}

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    async componentWillMount() {
      await this.props.getInfo()
    },
    componentWillReceiveProps(np) {
      if (np.id !== this.props.id) this.props.getInfo(np.id)
    }
  })
)(FundPage))



// WEBPACK FOOTER //
// ./src/containers/Fund.jsx